<form [formGroup]="scheduleDetailsForm" *ngIf="scheduleDetailsForm">

    <section class="k-d-grid k-gap-y-xl">
        <div class="k-d-flex k-gap-xl k-align-items-center">
            <kendo-svg-icon [icon]="chalkBordUser" size="medium"></kendo-svg-icon>
            <kendo-formfield class="k-w-full">
                <kendo-label text="Session Type" labelCssClass="hidden-label">
                    <kendo-dropdownlist placeholder='Session Type' formControlName="evaluationType"
                        [data]="referenceData.evaluationType" [valueField]="'id'" [textField]="'description'"
                        [disabled]="displayScheduleTimeButton"></kendo-dropdownlist>
                </kendo-label>
            </kendo-formfield>
        </div>

        <div class="k-d-flex k-gap-x-sm k-ml-10">
            <kendo-formfield class="k-w-full">
                <kendo-label text="Evaluator Name" labelCssClass="hidden-label">
                    <kendo-textbox formControlName="evaluatorName" placeholder="Evaluator Name">
                    </kendo-textbox>
                </kendo-label>
            </kendo-formfield>
            <kendo-formfield class="k-w-full">
                <kendo-label text="Evaluator Title" labelCssClass="hidden-label">
                    <kendo-textbox formControlName="evaluatorTitle" placeholder="Evaluator Title">
                    </kendo-textbox>
                </kendo-label>
            </kendo-formfield>
            <kendo-formfield class="k-w-full">
                <kendo-label text="Evaluator Phone" labelCssClass="hidden-label">
                     <kendo-maskedtextbox  placeholder="Evaluator Phone" formControlName="evaluatorPhone"
                        [mask]="'000-000-0000'">
                    </kendo-maskedtextbox>
                </kendo-label>
            </kendo-formfield>
            <kendo-formfield class="k-w-full">
                <kendo-label text="Evaluator Email" labelCssClass="hidden-label">
                    <kendo-textbox formControlName="evaluatorEmail" placeholder="Evaluator Email">
                    </kendo-textbox>
                </kendo-label>
            </kendo-formfield>
        </div>
    </section>
    <span class="k-form-separator !k-my-8"></span>
    <section class="k-d-grid k-gap-y-xl">
        <div class="k-d-flex k-gap-xl k-align-items-center">
            <kendo-svg-icon [icon]="clock" size="medium"></kendo-svg-icon>
            <div class="k-d-flex k-gap-x-sm k-align-items-center ">
                <!-- [class.has-error]="!checkValidServiceStartDate" -->
                <div class="k-d-flex  input-with-validation2">
                    <kendo-formfield [style.width.px]="160">
                        <kendo-label text="Start Date" labelCssClass="hidden-label">
                            <kendo-datepicker calendarType="classic" placeholder="Start Date"
                                formControlName="startDate" [min]="isNew ? today : startDate"></kendo-datepicker>
                        </kendo-label>

                    </kendo-formfield>
                </div>

                <kendo-formfield [style.width.px]="140">
                    <kendo-label text="Start Time" labelCssClass="hidden-label">
                        <kendo-timepicker placeholder="Start Time" [max]="endTimes"
                            formControlName="startTime"></kendo-timepicker>
                    </kendo-label>
                </kendo-formfield>
                <span class="k-d-flex k-align-items-center">to</span>
                <kendo-formfield [style.width.px]="140">
                    <kendo-label text="End Time" labelCssClass="hidden-label">
                        <kendo-timepicker placeholder="End Time" formControlName="endTime"
                            [min]="startTimes"></kendo-timepicker>
                    </kendo-label>
                </kendo-formfield>
                <span>{{duration}}</span>


            </div>
        </div>
        <!-------------Student/ Mandates------->
        <div class="k-d-flex k-gap-xl k-align-items-center">
          <kendo-svg-icon [icon]="users" size="medium"></kendo-svg-icon>
          <div class="student-mandates-wrapper">
            <span class="student-mandates-label">Students/Mandates</span>
            <div class="student-mandates-value">
              <ng-container *ngFor="let item of scheduleDetailsForm.get('studentName')?.value; let last = last">
                <span class="template">
                  {{ item.studentName }}
                </span>
                ({{ item.nycId }})<span *ngIf="!last">, </span>
              </ng-container>
            </div>
          </div>
        </div>

        <!-----------Participants------------>
        <div class="k-d-flex k-gap-xl k-align-items-start">
            <kendo-svg-icon [icon]="users" size="medium" class="k-mt-2">
            </kendo-svg-icon>

            <div class="k-d-grid k-gap-y-md k-flex-1">

                <kendo-formfield class="k-w-full">
                    <kendo-label text="Students" labelCssClass="hidden-label">
                        <div class="multiselect-wrapper">
                            <button type="button"
                                class="k-button k-button-solid k-button-md k-button-solid-base fake-prefix-btn"
                                disabled>
                                Required
                            </button>

                            <kendo-multiselecttree
                                placeholder="Search for and select from the list of required attendees for this meeting"
                                formControlName="requiredAttendees" kendoMultiSelectTreeExpandable
                                [kendoMultiSelectTreeHierarchyBinding]="requiredLookupData" textField="text"
                                valueField="id" childrenField="items" kendoMultiSelectTreeExpandable
                                [checkableSettings]="{ checkChildren: true }" (valueChange)="onAttendeesChange($event)">
                                <ng-template kendoMultiSelectTreeTagTemplate let-dataItem>
                                    <ng-container>
                                        {{ dataItem.text }}
                                    </ng-container>
                                </ng-template>
                            </kendo-multiselecttree>

                        </div>

                    </kendo-label>
                </kendo-formfield>

                <!-- <kendo-formfield class="k-w-full" >
                    <kendo-label text="Optional Attendees" labelCssClass="hidden-label">
                        <kendo-multiselect placeholder="Optional Attendees" [allowCustom]="true"
                            formControlName="optionalAttendees" [data]="optionalAttendeesList">
                            <ng-template kendoPrefixTemplate>
                                <button kendoButton [disabled]="true">Optional Attendees</button>
                            </ng-template>
                            <ng-template kendoMultiSelectTagTemplate let-dataItem>
                                <span class="template">{{ dataItem.name || dataItem }}</span>
                            </ng-template>
                        </kendo-multiselect>
                    </kendo-label>
                </kendo-formfield> -->

                <!-- <kendo-formfield class="k-w-full">
                    <kendo-label text="Required Attendees" labelCssClass="hidden-label">
                        <kendo-multiselect placeholder="Required Attendees" formControlName="requiredAttendees"
                            kendoMultiSelectTreeExpandable [kendoMultiSelectTreeHierarchyBinding]="requiredLookupData"
                            textField="text" valueField="id" childrenField="items">
                            <ng-template kendoPrefixTemplate>
                                <button kendoButton> Required Attendees </button>
                            </ng-template>
                        </kendo-multiselect>
                    </kendo-label>
                </kendo-formfield> -->

                <kendo-formfield class="k-w-full">
                    <kendo-label text="Optional Attendees" labelCssClass="hidden-label">
                        <div class="multiselect-wrapper">
                            <button type="button"
                                class="k-button k-button-solid k-button-md k-button-solid-base fake-prefix-btn"
                                disabled>
                                Optional
                            </button>
                            <kendo-multiselecttree
                                placeholder="Search for and select from the list of optional attendees for this meeting"
                                formControlName="optionalAttendees" kendoMultiSelectTreeExpandable
                                [kendoMultiSelectTreeHierarchyBinding]="requiredLookupData"
                                 textField="text"
                                valueField="id" childrenField="items" 
                                [checkableSettings]="{ checkChildren: true }"
                                (valueChange)="onOptionalAttendeesChange($event)">
                                <ng-template kendoMultiSelectTreeTagTemplate let-dataItem>
                                    <span>
                                        {{ dataItem.text }}
                                    </span>
                                </ng-template>
                            </kendo-multiselecttree>
                        </div>
                    </kendo-label>
                </kendo-formfield>
            </div>
        </div>

        <!------------Location---------------->
        <div class="k-d-flex k-gap-xl k-align-items-center">
            <kendo-svg-icon [icon]="locationDot" size="medium" class="k-mt-4"></kendo-svg-icon>
            <div class="k-d-flex k-gap-x-sm k-align-items-center">
                <kendo-formfield [style.width.px]="160">
                   <kendo-floatinglabel text="Location Type">
                        <kendo-dropdownlist [data]="referenceStore.scheduleLocationType$ | async" [valueField]="'id'"
                            [textField]="'description'" [itemDisabled]="disableLocationItem"
                            formControlName="locationType">
                        </kendo-dropdownlist>
                    </kendo-floatinglabel>
                </kendo-formfield>

                <kendo-formfield class="k-mt-5" [style.width.px]="559">
                    <kendo-label text="Location" labelCssClass="hidden-label">
                        <kendo-textbox placeholder="Location" formControlName="location" [maxlength]="120"></kendo-textbox>
                    </kendo-label>
                </kendo-formfield>
                <kendo-svg-icon [icon]="stairs" size="medium" class="floor-icon k-d-flex k-align-items-center"></kendo-svg-icon>
                <kendo-formfield class="k-mt-5" [style.width.px]="263">
                    <kendo-label text="Floor/Room" labelCssClass="hidden-label">
                        <kendo-textbox placeholder="Floor/Room" formControlName="floorRoom" [maxlength]="120"></kendo-textbox>
                    </kendo-label>
                </kendo-formfield>
            </div>
        </div>
        <!----------Teams Meeting Switch------->
        <div class="k-d-flex k-gap-x-sm k-ml-10">
            <kendo-formfield>
                <div class="k-d-flex k-gap-lg">
                    <kendo-label text="Teams Meeting / Tele">
                    </kendo-label>
                    <kendo-switch formControlName="teamsMeeting"></kendo-switch>
                </div>
            </kendo-formfield>
        </div>
        <div class="k-d-flex k-gap-xl k-align-items-center">
            <kendo-svg-icon [icon]="car" size="medium" class="k-mt-4"></kendo-svg-icon>
            <div>
                <p class="!k-mt-0 !k-mb-0">If you are taking transportation to get to this session, please indicate your travel
                    time below.</p>
                <div class="k-d-flex k-gap-x-lg k-align-items-center">
                    <!-- <kendo-formfield [style.width.px]="160">
                        <kendo-label text="Travel Method" labelCssClass="hidden-label">
                            <kendo-dropdownlist placeholder="Travel Method"
                                formControlName="travelMethod"></kendo-dropdownlist>
                        </kendo-label>
                    </kendo-formfield> -->
                    <!-- <span class="k-d-flex k-align-items-center">for</span> -->
                    <kendo-formfield [style.width.px]="140">
                        <kendo-label text="Minutes" labelCssClass="hidden-label">
                            <kendo-textbox placeholder="#" formControlName="minutes" inputmode="numeric"
                                pattern="[0-9]*" (input)="onMinutesInput($event)">
                                <ng-template kendoTextBoxSuffixTemplate>
                                    <button kendoButton [disabled]="true">minutes</button>
                                </ng-template>
                            </kendo-textbox>
                        </kendo-label>
                    </kendo-formfield>
                </div>
            </div>
        </div>
        <div class="k-d-flex k-gap-xl k-align-items-center">
            <kendo-svg-icon [icon]="indent"></kendo-svg-icon>
            <div class="k-d-grid k-flex-1">
                <kendo-formfield class="k-w-full k-mt-4">
                    <kendo-label text="Additional Information">
                        <kendo-textarea [rows]="3" placeholder="Type here"
                            formControlName="additionalInfo"></kendo-textarea>
                    </kendo-label>
                </kendo-formfield>
            </div>
        </div>
    </section>

</form>